// Short of the opposite edge, and capped at a comfortable reading measure.
export const MESSAGING_BUBBLE_MAX_WIDTH = 'min(680px, 78%)';

export const MESSAGING_BUBBLE_PADDING_X = 1.5;
